import React from 'react';
import IconBase from './IconBase';

const FullscreenIcon = props => {
    return (
        <IconBase viewBox={'0 0 40 40'} {...props}>
            <path d="M5,35v-8.1h2.8v5.4h5.4V35H5z M26.9,35v-2.8h5.4v-5.4H35V35H26.9z M5,13.1V5h8.1v2.8H7.8v5.4H5z M32.2,13.1V7.8h-5.4V5H35v8.1H32.2z"/>
        </IconBase>
    )
}

export default FullscreenIcon;